import { EndSellerNetwork } from '../../end-seller-network.setup';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import {
  PagePermission,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import {
  EndSellerManagementPointOfSaleTab,
  EndSellerManagementInvitationCodesTab,
  EndSellerManagementMetricsTab,
} from './tabs';

const parent = EndSellerNetwork.pages.endSellerManagement;
const title = 'PAGE.END_SELLER_NETWORK.MANAGEMENT.TITLE';
const tabs: TabPermission[] = [
  EndSellerManagementPointOfSaleTab,
  EndSellerManagementInvitationCodesTab,
  EndSellerManagementMetricsTab,
];

export const EndSellerManagementPage: PagePermission =
  PermissionsC.generatePagePermission(parent, title, tabs);
